// extracted by mini-css-extract-plugin
export default {"main":"Template_main__O7L05","content":"Template_content__8lbaK","areaLeft":"Template_areaLeft__ojO1o","areaRight":"Template_areaRight__wUNbY","debugBar":"Template_debugBar__kqw5N"};